/**
 * Contributor domain implementation for hen-site.
 * Import from `@hen-site/types/contributor` (barrel) or this path — both resolve here.
 */
export type { ContributorsConfig } from './config';
export * from './display';
export * from './path';
export * from './social';
export * from './types';
